import * as React from "react";
import { inject,observer } from 'mobx-react';
import {  autorun } from "mobx";
import ModelStore from 'src/stores/ModelStore';
import './NavigationComponent.scss';
import IModelFormat from "src/interfaces/IModelFormat";
import IMenuItem from "src/interfaces/IMenuItem";

interface IState {
  scrollbar: boolean;
  scroll: number;
  menu: IMenuItem | null;
}

interface IProps {
  modelStore?: ModelStore;
}
@inject("modelStore")
@observer
export default class SubNavigationComponent extends React.Component<IProps,IState> {


  private hammer:any;
  private autoUpdateDisposer: any;
  private maxScroll:number = 0;
  

  constructor(props?: any, context?: any) {
    super(props, context);
    this.state={
      menu: null ,
      scroll: 0 , 
      scrollbar: false ,
      
    }
    this.scrollLeft=this.scrollLeft.bind(this);
    this.scrollRight=this.scrollRight.bind(this);
    this.onResize=this.onResize.bind(this);
 
  }

  public render() {
    const modelStore = this.props.modelStore as ModelStore;

    const styles={
      transform : "translateX(" + (-160 * this.state.scroll) +"px)"
    }

      return (
        <div className={ "scroll-wrap sub-nav "  + modelStore.selectedMenu!.title.toLowerCase() }>
          <div className="scroll-content" style={styles} >
            { this._renderSubItems()}
          </div>
          <div className={"scroll-button scroll-left" + (this.state.scroll<=0 ? " disabled":"" )} onClick={this.scrollLeft} />
          <div className={"scroll-button scroll-right" + (this.state.scroll>= this.maxScroll ? " disabled":"") } onClick={this.scrollRight} />
        </div>
    );

     
  }

  public componentDidMount() {
    this.autoUpdateDisposer = autorun(() => {
      const modelStore = this.props.modelStore as ModelStore;
      console.log(modelStore.selectedMenu);
      this.setState({ menu: modelStore.selectedMenu })
    });

    this.hammer = new Hammer(document.querySelector(".scroll-wrap") as HTMLDivElement);
    this.hammer.on('swipeleft', this.scrollRight);
    this.hammer.on('swiperight', this.scrollLeft);

    window.addEventListener("resize",this.onResize);
  }

  public componentWillUnmount() {
    this.autoUpdateDisposer();
    window.removeEventListener("resize",this.onResize);
  }

  public componentDidUpdate(prevProps:IProps,prevState:IState){
      if(prevState.menu !== this.state.menu ){
        this.setupScrollView();
      }
  }

  
  
  private scrollRight(){
    if(this.state.scroll < this.maxScroll ){
      this.setState({ scroll: this.state.scroll + 1  });
    }
    
  
  }
  private scrollLeft(){
    if(this.state.scroll>0){
      this.setState({ scroll: this.state.scroll - 1  });
    }
    

  }
  
  private onResize(){
    this.setupScrollView()
  }
 

  private setupScrollView(){
    const wrap = document.querySelector(".scroll-wrap") as HTMLDivElement;
    const content = document.querySelector(".scroll-content") as HTMLDivElement;
    if(wrap == null){
      return;
    }
    if(wrap.clientWidth < content.clientWidth){
        this.setState({scrollbar:true , scroll: 0 })
        this.maxScroll =  Math.ceil((content.clientWidth - wrap.clientWidth) / 160);
    }else{
        this.setState({scrollbar: false , scroll: 0})
        this.maxScroll = 0;
    }
  }

 

  private _selectModel (model:IModelFormat){
    const modelStore = this.props.modelStore as ModelStore;
    modelStore.setSelectedSubMenuItem(model);
    
  }

  private _renderSubItems():React.ReactNode[]{
    const modelStore = this.props.modelStore as ModelStore;
    const items:any[] = [];
    modelStore!.subMenu!.map( 
      (model: IModelFormat , index: number )=>{
      const styles={
        background: "url('"+ this.getIcon(model) +"') center center / contain no-repeat"
      }  
      items.push(<div key={'card-' + index } className={ model.selected ? "sub-nav-item selected" : "sub-nav-item"} onClick={ this._selectModel.bind(this, model) } ><div className="icon" style={styles}  /><div className="label"><span>{ model.title }</span></div></div>);
    }); 
    

    return items;
  }
  private getIcon(model:any):string{
    if(model.icons && model.icons.length > 0 ){
      return  model.icons[0];
    }
    if(model.icon && model.icon.length > 0 ){
      return  model.icon[0];
    }
    if(model.images && model.images.length > 0 ){
      return  model.images[0];
    }

    return "";
  }
}


// WEBPACK FOOTER //
// ./src/components/SubNavigationComponent.tsx